import Immutable from 'immutable';

export enum Roles {
  admin = 'admin',
  member = 'member',
  viewer = 'viewer',
}

export interface RawRole {
  projectid: string;
  userid: string;
  role: Roles;
  assignedRole: Roles;
}

const defaultValues: RawRole = {
  projectid: '',
  userid: '',
  role: Roles.viewer,
  assignedRole: Roles.viewer,
};

export const RoleFactory = Immutable.Record(defaultValues, 'Role');

export class Role extends RoleFactory {
  static deserialize(rawRole: RawRole): Role {
    return new Role({
      ...rawRole,
      role: Roles[rawRole.role] || Roles.viewer,
    });
  }

  serialize(): RawRole {
    return this.toObject();
  }
}

export type RoleMap = Immutable.Map<string, Role>;
